import React, { useState, useEffect, Fragment } from "react";

const useCertificationTable = (
  CertifArray,
  handleDelCertification,
  handleEditCertification,
  onClickToggleFromTable
) => {
  const [thead] = useState(["Certification", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = CertifArray.map((el) => {
      return {
        "Certification": el.certificationName,
        Action: (
          <Fragment>
             <i
              className="fas fa-edit ml-4" 
              style={{ marginRight: "10px", cursor: "pointer" }}             
              onClick={() => {
                handleEditCertification(el, el.certificationId);
                onClickToggleFromTable();
             }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelCertification(el.certificationId)}
            ></i>
           
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    CertifArray,
    handleDelCertification,
    handleEditCertification,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default useCertificationTable;